"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./sass/inputCheckbox.scss");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _iconsReact = require("@carbon/icons-react");

var _excluded = ["id", "name", "children", "onChange", "value", "checked", "disabled", "className", "readOnly"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function InputCheckbox(_ref) {
  var id = _ref.id,
      name = _ref.name,
      children = _ref.children,
      onChange = _ref.onChange,
      value = _ref.value,
      checked = _ref.checked,
      disabled = _ref.disabled,
      className = _ref.className,
      readOnly = _ref.readOnly,
      props = _objectWithoutProperties(_ref, _excluded);

  var checkboxClasses = _defineProperty({
    checkboxInput_disabled: disabled
  }, "".concat(className), className);

  return /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: (0, _classnames.default)('checkboxInput', checkboxClasses)
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    type: "checkbox",
    id: id,
    name: name,
    onChange: onChange,
    disabled: disabled,
    value: value,
    checked: checked,
    className: "checkboxInput_input",
    readOnly: readOnly
  }, props)), /*#__PURE__*/_react.default.createElement("span", {
    className: "checkboxInput_checkmark"
  }, checked ? /*#__PURE__*/_react.default.createElement(_iconsReact.CheckboxCheckedFilled32, {
    fill: "#008CFF"
  }) : /*#__PURE__*/_react.default.createElement(_iconsReact.Checkbox32, {
    fill: "#546982"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "checkboxInput_label"
  }, children));
}

InputCheckbox.propTypes = {
  id: _propTypes.default.string,
  name: _propTypes.default.string,
  children: _propTypes.default.string,
  onChange: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  value: _propTypes.default.bool,
  checked: _propTypes.default.bool,
  readOnly: _propTypes.default.bool
};
InputCheckbox.defaultProps = {
  id: null,
  name: null,
  children: 'Default label',
  onChange: null,
  disabled: false,
  value: null,
  checked: null,
  readOnly: false
};
var _default = InputCheckbox;
exports.default = _default;